import type { AgentRecommendation } from "./schemas.js";

/**
 * Category-to-recommendation key mapping.
 * Maps spec categories to agent recommendation keys from agents.yaml.
 */
const CATEGORY_MAP: Record<string, string> = {
  infrastructure: "scaffolding",
  frontend: "standard-crud",
  backend: "standard-crud",
  performance: "debugging",
  "bug fix": "debugging",
  integration: "complex-implementation",
  design: "standard-crud",
  architecture: "architecture",
  security: "complex-implementation",
  devops: "scaffolding",
  documentation: "documentation",
  testing: "test-generation",
  refactoring: "refactoring-architectural",
};

const DEFAULT_MODEL = "claude-sonnet-4-6";

export function recommendModel(
  category: string,
  recommendations: Record<string, AgentRecommendation>,
): AgentRecommendation {
  const key = CATEGORY_MAP[category.toLowerCase()];
  if (key && recommendations[key]) {
    return recommendations[key];
  }

  // Try direct match
  const direct = recommendations[category.toLowerCase()];
  if (direct) return direct;

  return { model: DEFAULT_MODEL, reason: "Default balanced model" };
}
